<template>
    <div class="military_wrap">
        <img src="../../assets/imgs/military_bg.jpg" alt />
        <!-- 导航栏 -->
        <ul class="nav animate__animated animate__fadeInUp">
            <li :class="{ libg: isjun, jun_on: isjun }" @click="handelTab('jun')"></li>
            <li :class="{ libg: isgong, gong_on: isgong }" @click="handelTab('gong')"></li>
            <li :class="{ libg: isqi, qi_on: isqi }" @click="handelTab('qi')"></li>
            <li :class="{ libg: isbu, bu_on: isbu }" @click="handelTab('bu')"></li>
        </ul>
        <!-- 使用animate.css 外面需要再包裹一层 v-if 外面div -->
        <!-- jun 的内容 -->
        <div class="jun">
            <div v-show="con === 'jun'">
                <div class="camp_people">
                    <img src="../../assets/camp_jun/1p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'jun' && this.selectedCamp == 'c1'" />
                    <img src="../../assets/camp_jun/2p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'jun' && this.selectedCamp == 'c2'" />
                    <img src="../../assets/camp_jun/3p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'jun' && this.selectedCamp == 'c3'" />
                </div>
                <div class="content">
                    <img src="../../assets/camp_jun/1i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'jun' && this.selectedCamp == 'c1'" />
                    <img src="../../assets/camp_jun/2i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'jun' && this.selectedCamp == 'c2'" />
                    <img src="../../assets/camp_jun/3i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'jun' && this.selectedCamp == 'c3'" />
                    <!-- 武将swiper -->
                    <div class="camp_all camp_jun animate__animated animate__fadeInUp">
                        <swiper :options="swiperOption_jun" ref="mySwiper">
                            <swiper-slide
                                v-for="(item, index) in junCampList"
                                :key="item.id"
                                :class="{
                                    jun_c2: item.class == 'jun_c2',
                                    active: activeInitIndex == index,
                                }"
                            >
                                <span @click="handleClickSwiper(item.type, item.name)"></span>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- gong 的内容 -->
        <div class="gong">
            <div v-show="con === 'gong'">
                <div class="camp_people">
                    <img src="../../assets/camp_gong/1p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c1'" />
                    <img src="../../assets/camp_gong/2p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c2'" />
                    <img src="../../assets/camp_gong/3p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c3'" />
                    <img src="../../assets/camp_gong/4p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c4'" />
                    <img src="../../assets/camp_gong/5p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c5'" />
                    <img src="../../assets/camp_gong/6p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c6'" />
                    <img src="../../assets/camp_gong/7p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c7'" />
                    <img src="../../assets/camp_gong/8p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c8'" />
                    <img src="../../assets/camp_gong/9p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c9'" />
                    <img src="../../assets/camp_gong/10p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c10'" />
                    <img src="../../assets/camp_gong/11p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c11'" />
                    <img src="../../assets/camp_gong/12p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c12'" />
                    <img src="../../assets/camp_gong/13p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c13'" />
                    <img src="../../assets/camp_gong/14p.png" alt class="animate__animated animate__fadeInLeft"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c14'" />
                </div>
                <div class="content">
                    <img src="../../assets/camp_gong/1i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c1'" />
                    <img src="../../assets/camp_gong/2i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c2'" />
                    <img src="../../assets/camp_gong/3i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c3'" />
                    <img src="../../assets/camp_gong/4i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c4'" />
                    <img src="../../assets/camp_gong/5i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c5'" />
                    <img src="../../assets/camp_gong/6i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c6'" />
                    <img src="../../assets/camp_gong/7i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c7'" />
                    <img src="../../assets/camp_gong/8i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c8'" />
                    <img src="../../assets/camp_gong/9i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c9'" />
                    <img src="../../assets/camp_gong/10i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c10'" />
                    <img src="../../assets/camp_gong/11i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c11'" />
                    <img src="../../assets/camp_gong/12i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c12'" />
                    <img src="../../assets/camp_gong/13i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c13'" />
                    <img src="../../assets/camp_gong/14i.png" alt class="img c_info animate__animated animate__fadeInRight"
                     v-show="this.selectedCampType == 'gong' && this.selectedCamp == 'c14'" />
                    <!-- 武将swiper -->
                    <div class="camp_all camp_gong animate__animated animate__fadeInUp">
                        <swiper :options="swiperOption_gong" ref="mySwiper">
                            <swiper-slide
                                v-for="(item, index) in gongCampList"
                                :key="item.id"
                                :class="{
                                    active: activeInitIndex == index,
                                }"
                            >
                                <span @click="handleClickSwiper(item.type, item.name)"></span>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- qi的内容 -->
        <div class="qi">
            <div v-show="con === 'qi'">
                <div class="camp_people">
                    <img src="../../assets/camp_qi/1p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c1' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/2p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c2' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/3p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c3' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/4p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c4' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/5p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c5' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/6p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c6' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/7p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c7' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/8p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c8' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/9p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c9' && selectedCampType == 'qi'" />
                </div>
                <div class="content">
                    <img src="../../assets/camp_qi/1i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c1' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/2i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c2' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/3i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c3' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/4i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c4' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/5i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c5' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/6i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c6' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/7i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c7' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/8i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c8' && selectedCampType == 'qi'" />
                    <img src="../../assets/camp_qi/9i.png" alt class="img c_info animate__animated animate__fadeInRight"
                    v-show="selectedCamp == 'c9' && selectedCampType == 'qi'" />
                    <!-- 武将swiper -->
                    <div class="camp_all camp_qi animate__animated animate__fadeInUp">
                        <swiper :options="swiperOption_qi" ref="mySwiper">
                            <swiper-slide
                                v-for="(item, index) in qiCampList"
                                :key="item.id"
                                :class="{
                                    active: activeInitIndex == index,
                                }"
                            >
                                <span @click="handleClickSwiper(item.type, item.name)"></span>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- bu的内容 -->
        <div class="bu">
            <div v-show="con === 'bu'">
                <div class="camp_people">
                    <img src="../../assets/camp_bu/1p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c1' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/2p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c2' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/3p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c3' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/4p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c4' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/5p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c5' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/6p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c6' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/7p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c7' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/8p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c8' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/9p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c9' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/10p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c10' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/11p.png" alt class="animate__animated animate__fadeInLeft" v-show="selectedCamp == 'c11' && selectedCampType == 'bu'" />
                </div>
                <div class="content">
                    <img src="../../assets/camp_bu/1i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c1' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/2i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c2' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/3i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c3' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/4i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c4' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/5i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c5' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/6i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c6' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/7i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c7' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/8i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c8' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/9i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c9' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/10i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c10' && selectedCampType == 'bu'" />
                    <img src="../../assets/camp_bu/11i.png" alt class="img c_info animate__animated animate__fadeInRight" v-show="selectedCamp == 'c11' && selectedCampType == 'bu'" />
                    <!-- 武将swiper -->
                    <div class="camp_all camp_bu animate__animated animate__fadeInUp">
                        <swiper :options="swiperOption_bu" ref="mySwiper">
                            <swiper-slide
                                v-for="(item, index) in buCampList"
                                :key="item.id"
                                :class="{
                                    active: activeInitIndex == index,
                                }"
                            >
                                <span @click="handleClickSwiper(item.type, item.name)"></span>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 遮罩部分 -->
    </div>
</template>

<script>
import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
Vue.use(VueAwesomeSwiper);
export default {
    name: "Hero",
    props: {
        msg: String
    },
    data () {
        return {
            isjun: true,
            isgong: false,
            isqi: false,
            isbu: false,
            flag: 0,
            con: "jun",
            isMask: false,
            swiperOption_jun: {
                slidesPerView: "auto",
                spaceBetween: 10,
                loop: false,
                autoplay: false,
                grabCursor: true,
                autoHeight: true,
                observer: true,
                observeParents: true,
                prevButton: ".camp_jun .swiper-button-prev",
                nextButton: ".camp_jun .swiper-button-next",
                onTap: (swiper) => {
                    console.log("你tap了swiper", swiper);
                    let index = swiper["clickedIndex"];
                    this.tabActiveClass("jun", index);
                }
            },
            swiperOption_gong: {
                slidesPerView: "auto",
                spaceBetween: 10,
                loop: false,
                autoplay: false,
                grabCursor: true,
                autoHeight: true,
                observer: true,
                observeParents: true,
                prevButton: ".camp_gong .swiper-button-prev",
                nextButton: ".camp_gong .swiper-button-next",
                onTap: (swiper) => {
                    let index = swiper["clickedIndex"];
                    this.tabActiveClass("gong", index);
                }
            },
            swiperOption_qi: {
                slidesPerView: "auto",
                spaceBetween: 10,
                loop: false,
                autoplay: false,
                grabCursor: true,
                autoHeight: true,
                observer: true,
                observeParents: true,
                prevButton: ".camp_qi .swiper-button-prev",
                nextButton: ".camp_qi .swiper-button-next",
                onTap: (swiper) => {
                    let index = swiper["clickedIndex"];
                    this.tabActiveClass("qi", index);
                }
            },
            swiperOption_bu: {
                slidesPerView: "auto",
                spaceBetween: 10,
                loop: false,
                autoplay: false,
                grabCursor: true,
                autoHeight: true,
                observer: true,
                observeParents: true,
                prevButton: ".camp_bu .swiper-button-prev",
                nextButton: ".camp_bu .swiper-button-next",
                onTap: (swiper) => {
                    let index = swiper["clickedIndex"];
                    this.tabActiveClass("bu", index);
                }
            },
            junArr: [ 0, 1, 2, 3, 4, 5, 6, 7, 8 ],
            gongArr: [ 0, 1, 2, 3, 4, 5, 6, 7, 8 ],
            qiArr: [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9 ],
            buArr: [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9 ],
            junPopList: [
                {
                    id: "01",
                    imgSrc: require("../../assets/junpop/1-1.png")
                },
                {
                    id: "02",
                    imgSrc: require("../../assets/junpop/1-2.png")
                },
                {
                    id: "03",
                    imgSrc: require("../../assets/junpop/1-3.png")
                },
                {
                    id: "04",
                    imgSrc: require("../../assets/junpop/1-4.png")
                },
                {
                    id: "05",
                    imgSrc: require("../../assets/junpop/1-5.png")
                },
                {
                    id: "06",
                    imgSrc: require("../../assets/junpop/1-6.png")
                },
                {
                    id: "07",
                    imgSrc: require("../../assets/junpop/1-7.png")
                },
                {
                    id: "08",
                    imgSrc: require("../../assets/junpop/1-8.png")
                },
                {
                    id: "09",
                    imgSrc: require("../../assets/junpop/1-9.png")
                }
            ],
            gongPopList: [
                {
                    id: "001",
                    imgSrc: require("../../assets/gongpop/1-1.png")
                },
                {
                    id: "002",
                    imgSrc: require("../../assets/gongpop/1-2.png")
                },
                {
                    id: "003",
                    imgSrc: require("../../assets/gongpop/1-3.png")
                },
                {
                    id: "004",
                    imgSrc: require("../../assets/gongpop/1-4.png")
                },
                {
                    id: "005",
                    imgSrc: require("../../assets/gongpop/1-5.png")
                },
                {
                    id: "006",
                    imgSrc: require("../../assets/gongpop/1-6.png")
                },
                {
                    id: "007",
                    imgSrc: require("../../assets/gongpop/1-7.png")
                },
                {
                    id: "008",
                    imgSrc: require("../../assets/gongpop/1-8.png")
                },
                {
                    id: "009",
                    imgSrc: require("../../assets/gongpop/1-9.png")
                }
            ],
            qiPopList: [
                {
                    id: "0001",
                    imgSrc: require("../../assets/qipop/1-1.png")
                },
                {
                    id: "0002",
                    imgSrc: require("../../assets/qipop/1-2.png")
                },
                {
                    id: "0003",
                    imgSrc: require("../../assets/qipop/1-3.png")
                },
                {
                    id: "0004",
                    imgSrc: require("../../assets/qipop/1-4.png")
                },
                {
                    id: "0005",
                    imgSrc: require("../../assets/qipop/1-5.png")
                },
                {
                    id: "0006",
                    imgSrc: require("../../assets/qipop/1-6.png")
                },
                {
                    id: "0007",
                    imgSrc: require("../../assets/qipop/1-7.png")
                },
                {
                    id: "0008",
                    imgSrc: require("../../assets/qipop/1-8.png")
                },
                {
                    id: "0009",
                    imgSrc: require("../../assets/qipop/1-9.png")
                },
                {
                    id: "0010",
                    imgSrc: require("../../assets/qipop/1-10.png")
                }
            ],
            buPopList: [
                {
                    id: "00001",
                    imgSrc: require("../../assets/bupop/1-1.png")
                },
                {
                    id: "00002",
                    imgSrc: require("../../assets/bupop/1-2.png")
                },
                {
                    id: "00003",
                    imgSrc: require("../../assets/bupop/1-3.png")
                },
                {
                    id: "00004",
                    imgSrc: require("../../assets/bupop/1-4.png")
                },
                {
                    id: "00005",
                    imgSrc: require("../../assets/bupop/1-5.png")
                },
                {
                    id: "00006",
                    imgSrc: require("../../assets/bupop/1-6.png")
                },
                {
                    id: "00007",
                    imgSrc: require("../../assets/bupop/1-7.png")
                },
                {
                    id: "00008",
                    imgSrc: require("../../assets/bupop/1-8.png")
                },
                {
                    id: "00009",
                    imgSrc: require("../../assets/bupop/1-9.png")
                },
                {
                    id: "00010",
                    imgSrc: require("../../assets/bupop/1-10.png")
                }
            ],
            junCampList: [
                {
                    id: "01",
                    imgSrc: require("../../assets/camp_jun/c1.png"),
                    type: "jun",
                    name: "c1"
                },
                {
                    id: "02",
                    imgSrc: require("../../assets/camp_jun/c2.png"),
                    class: "jun_c2",
                    type: "jun",
                    name: "c2"
                },
                {
                    id: "03",
                    imgSrc: require("../../assets/camp_jun/c3.png"),
                    type: "jun",
                    name: "c3"
                }
            ],
            gongCampList: [
                {
                    id: "01",
                    type: "gong",
                    name: "c1"
                },
                {
                    id: "02",
                    type: "gong",
                    name: "c2"
                },
                {
                    id: "03",
                    type: "gong",
                    name: "c3"
                },
                {
                    id: "04",
                    type: "gong",
                    name: "c4"
                },
                {
                    id: "05",
                    type: "gong",
                    name: "c5"
                },
                {
                    id: "06",
                    type: "gong",
                    name: "c6"
                },
                {
                    id: "07",
                    type: "gong",
                    name: "c7"
                },
                {
                    id: "08",
                    type: "gong",
                    name: "c8"
                },
                {
                    id: "09",
                    type: "gong",
                    name: "c9"
                },
                {
                    id: "10",
                    type: "gong",
                    name: "c10"
                },
                {
                    id: "11",
                    type: "gong",
                    name: "c11"
                },
                {
                    id: "12",
                    type: "gong",
                    name: "c12"
                },
                {
                    id: "13",
                    type: "gong",
                    name: "c13"
                },
                {
                    id: "14",
                    type: "gong",
                    name: "c14"
                }
            ],
            qiCampList: [
                {
                    id: "01",
                    type: "qi",
                    name: "c1"
                },
                {
                    id: "02",
                    type: "qi",
                    name: "c2"
                },
                {
                    id: "03",
                    type: "qi",
                    name: "c3"
                },
                {
                    id: "04",
                    type: "qi",
                    name: "c4"
                },
                {
                    id: "05",
                    type: "qi",
                    name: "c5"
                },
                {
                    id: "06",
                    type: "qi",
                    name: "c6"
                },
                {
                    id: "07",
                    type: "qi",
                    name: "c7"
                },
                {
                    id: "08",
                    type: "qi",
                    name: "c8"
                },
                {
                    id: "09",
                    type: "qi",
                    name: "c9"
                }
            ],
            buCampList: [
                {
                    id: "01",
                    type: "bu",
                    name: "c1"
                },
                {
                    id: "02",
                    type: "bu",
                    name: "c2"
                },
                {
                    id: "03",
                    type: "bu",
                    name: "c3"
                },
                {
                    id: "04",
                    type: "bu",
                    name: "c4"
                },
                {
                    id: "05",
                    type: "bu",
                    name: "c5"
                },
                {
                    id: "06",
                    type: "bu",
                    name: "c6"
                },
                {
                    id: "07",
                    type: "bu",
                    name: "c7"
                },
                {
                    id: "08",
                    type: "bu",
                    name: "c8"
                },
                {
                    id: "09",
                    type: "bu",
                    name: "c9"
                },
                {
                    id: "10",
                    type: "bu",
                    name: "c10"
                },
                {
                    id: "11",
                    type: "bu",
                    name: "c11"
                }
            ],
            selectedType: "",
            activeInitIndex: 0,
            selectedCamp: "c1",
            selectedCampType: "jun"
        };
    },
    // computed: {
    //     swiper () {
    //         console.log("mySwiper存在么", this.$refs.mySwiper);
    //         return this.$refs.mySwiper.swiper;
    //     }
    // },
    mounted () {},
    methods: {
        handelTab (type) {
            this.selectedCampType = type;
            this.selectedCamp = "c1";
            console.log("当前切换的模块", type, this.selectedCamp);
            switch (type) {
            case "jun":
                this.isjun = true;
                this.isgong = false;
                this.isqi = false;
                this.isbu = false;
                this.con = "jun";
                break;
            case "gong":
                this.isjun = false;
                this.isgong = true;
                this.isqi = false;
                this.isbu = false;
                this.con = "gong";
                break;
            case "qi":
                this.isjun = false;
                this.isgong = false;
                this.isqi = true;
                this.isbu = false;
                this.con = "qi";
                break;
            case "bu":
                this.isjun = false;
                this.isgong = false;
                this.isqi = false;
                this.isbu = true;
                this.con = "bu";
            }
        },
        closeMask () {
            this.isMask = !this.isMask;
            this.selectedType = "";
            this.swiper.slideTo(0, 0, false);
        },
        popShow (type, index) {
            this.isMask = true;
            this.selectedType = type;
            this.swiper.slideTo(index, 0, false);
        },
        handleClickSwiper (type, name) {
            console.log("模块", type, "名字", name);
            this.selectedCampType = type;
            this.selectedCamp = name;
        },
        tabActiveClass (type, i) {
            console.log("zzq当前点的是index是" + type, i);
            switch (type) {
            case "jun":
                $(".camp_jun .swiper-slide")
                    .eq(i)
                    .addClass("active")
                    .siblings()
                    .removeClass("active");
                break;
            case "gong":
                $(".camp_gong .swiper-slide")
                    .eq(i)
                    .addClass("active")
                    .siblings()
                    .removeClass("active");
                break;
            case "qi":
                $(".camp_qi .swiper-slide")
                    .eq(i)
                    .addClass("active")
                    .siblings()
                    .removeClass("active");
                break;
            case "bu":
                $(".camp_bu .swiper-slide")
                    .eq(i)
                    .addClass("active")
                    .siblings()
                    .removeClass("active");
            }
        }
    }
};
</script>

<style scoped lang="scss">
/*camp_qi*/
.camp_jun ::v-deep .swiper-container .swiper-wrapper {
    align-items: center;
}
.camp_jun ::v-deep .swiper-slide span {
    display: inline-block;
    width: 0.9rem;
    height: 1.2rem;
    background: url('.././../assets/camp_jun/all.png') no-repeat;
    background-size: 3.59rem 1.16rem;
}
.camp_jun ::v-deep .active span {
    display: inline-block;
    width: 0.9rem;
    height: 1.2rem;
    background: url('.././../assets/camp_jun/all_on.png') no-repeat;
    background-size: 3.59rem 1.16rem;
}
.camp_jun ::v-deep .swiper-slide:nth-child(1) span {
    background-position: 0 0;
}
.camp_jun ::v-deep .swiper-slide:nth-child(2) span {
    background-position: -1.46rem 0;
}
.camp_jun ::v-deep .swiper-slide:nth-child(3) span {
    background-position: -2.77rem 0;
}
/*camp_qi*/
.camp_gong ::v-deep .swiper-container .swiper-wrapper {
    align-items: center;
}
.camp_gong ::v-deep .swiper-slide span {
    display: inline-block;
    width: 0.9rem;
    height: 1.2rem;
    background: url('.././../assets/camp_gong/all.png') no-repeat;
    background-size: 18.84rem 1.16rem;
}
.camp_gong ::v-deep .active span {
    display: inline-block;
    width: 0.9rem;
    height: 1.2rem;
    background: url('.././../assets/camp_gong/all_on.png') no-repeat;
    background-size: 18.84rem 1.16rem;
}
.camp_gong ::v-deep .swiper-slide:nth-child(1) span {
    background-position: 0 0;
}
.camp_gong ::v-deep .swiper-slide:nth-child(2) span {
    background-position: -1.46rem 0;
}
.camp_gong ::v-deep .swiper-slide:nth-child(3) span {
    background-position: -2.77rem 0;
}
.camp_gong ::v-deep .swiper-slide:nth-child(4) span {
    background-position: -4.21rem 0;
}
.camp_gong ::v-deep .swiper-slide:nth-child(5) span {
    background-position: -5.55rem 0;
}
.camp_gong ::v-deep .swiper-slide:nth-child(6) span {
    background-position: -6.87rem 0;
}
.camp_gong ::v-deep .swiper-slide:nth-child(7) span {
    background-position: -8.34rem 0;
}
.camp_gong ::v-deep .swiper-slide:nth-child(8) span {
    background-position: -9.63rem 0;
}
.camp_gong ::v-deep .swiper-slide:nth-child(9) span {
    background-position: -11.03rem 0;
}
.camp_gong ::v-deep .swiper-slide:nth-child(10) span {
    background-position: -12.45rem 0;
}
.camp_gong ::v-deep .swiper-slide:nth-child(11) span {
    background-position: -13.81rem 0;
}
.camp_gong ::v-deep .swiper-slide:nth-child(12) span {
    background-position: -15.3rem 0;
}
.camp_gong ::v-deep .swiper-slide:nth-child(13) span {
    background-position: -16.73rem 0;
}
.camp_gong ::v-deep .swiper-slide:nth-child(14) span {
    background-position: -18.11rem 0;
}
/*camp_qi*/
.camp_qi ::v-deep .swiper-container .swiper-wrapper {
    align-items: center;
}
.camp_qi ::v-deep .swiper-slide span {
    display: inline-block;
    width: 0.9rem;
    height: 1.2rem;
    background: url('.././../assets/camp_qi/all.png') no-repeat;
    background-size: 11.94rem 1.16rem;
}
.camp_qi ::v-deep .active span {
    display: inline-block;
    width: 0.9rem;
    height: 1.2rem;
    background: url('.././../assets/camp_qi/all_on.png') no-repeat;
    background-size: 11.94rem 1.16rem;
}
.camp_qi ::v-deep .swiper-slide:nth-child(1) span {
    background-position: 0 0;
}
.camp_qi ::v-deep .swiper-slide:nth-child(2) span {
    background-position: -1.46rem 0;
}
.camp_qi ::v-deep .swiper-slide:nth-child(3) span {
    background-position: -2.77rem 0;
}
.camp_qi ::v-deep .swiper-slide:nth-child(4) span {
    background-position: -4.21rem 0;
}
.camp_qi ::v-deep .swiper-slide:nth-child(5) span {
    background-position: -5.55rem 0;
}
.camp_qi ::v-deep .swiper-slide:nth-child(6) span {
    background-position: -6.87rem 0;
}
.camp_qi ::v-deep .swiper-slide:nth-child(7) span {
    background-position: -8.34rem 0;
}
.camp_qi ::v-deep .swiper-slide:nth-child(8) span {
    background-position: -9.63rem 0;
}
.camp_qi ::v-deep .swiper-slide:nth-child(9) span {
    background-position: -11.03rem 0;
}
.camp_qi ::v-deep .swiper-slide:nth-child(10) span {
    background-position: -12.45rem 0;
}
.camp_qi ::v-deep .swiper-slide:nth-child(11) span {
    background-position: -13.81rem 0;
}
.camp_qi ::v-deep .swiper-slide:nth-child(12) span {
    background-position: -15.3rem 0;
}
.camp_qi ::v-deep .swiper-slide:nth-child(13) span {
    background-position: -16.73rem 0;
}
.camp_qi ::v-deep .swiper-slide:nth-child(14) span {
    background-position: -18.11rem 0;
}

/*camp_bu*/
.camp_bu ::v-deep .swiper-container .swiper-wrapper {
    align-items: center;
}
.camp_bu ::v-deep .swiper-slide span {
    display: inline-block;
    width: 0.9rem;
    height: 1.2rem;
    background: url('.././../assets/camp_bu/all.png') no-repeat;
    background-size: 14.65rem 1.16rem;
}
.camp_bu ::v-deep .active span {
    display: inline-block;
    width: 0.9rem;
    height: 1.2rem;
    background: url('.././../assets/camp_bu/all_on.png') no-repeat;
    background-size: 14.65rem 1.16rem;
}
.camp_bu ::v-deep .swiper-slide:nth-child(1) span {
    background-position: 0 0;
}
.camp_bu ::v-deep .swiper-slide:nth-child(2) span {
    background-position: -1.46rem 0;
}
.camp_bu ::v-deep .swiper-slide:nth-child(3) span {
    background-position: -2.77rem 0;
}
.camp_bu ::v-deep .swiper-slide:nth-child(4) span {
    background-position: -4.21rem 0;
}
.camp_bu ::v-deep .swiper-slide:nth-child(5) span {
    background-position: -5.55rem 0;
}
.camp_bu ::v-deep .swiper-slide:nth-child(6) span {
    background-position: -6.87rem 0;
}
.camp_bu ::v-deep .swiper-slide:nth-child(7) span {
    background-position: -8.34rem 0;
}
.camp_bu ::v-deep .swiper-slide:nth-child(8) span {
    background-position: -9.63rem 0;
}
.camp_bu ::v-deep .swiper-slide:nth-child(9) span {
    background-position: -11.03rem 0;
}
.camp_bu ::v-deep .swiper-slide:nth-child(10) span {
    background-position: -12.45rem 0;
}
.camp_bu ::v-deep .swiper-slide:nth-child(11) span {
    background-position: -13.81rem 0;
}

.camp_all ::v-deep .swiper-wrapper{
    height: 1.4rem !important;
}
.animate__animated {
    animation-duration: 0.4s;
}
.swiper-button-prev,
.swiper-button-next {
    transition: all 0.9s;
}
.swiper-button-prev:after {
    content: '';
    width: 0.43rem;
    height: 0.84rem;
    background: url('.././../assets/left.png') no-repeat;
    background-size: 100% 100%;
}
.swiper-button-next:after {
    content: '';
    width: 0.43rem;
    height: 0.84rem;
    background: url('.././../assets/left.png') no-repeat;
    background-size: 100% 100%;
    transform: rotate(180deg);
}
.swiper-container {
    /**width: 100%;**/
    width: 6.35rem;
    height: 100%;
}
.swiper-button-prev {
    left: 3.5%;
    z-index: 999999;
}
.swiper-button-next {
    right: 3.5%;
    z-index: 999999;
}
.swiper-slide {
    width: 0.8rem !important;
    height: 93%;
    margin-right: 0.58rem !important;
    cursor: pointer;
}
.active {
    transition: all 0.3s;
    border-bottom: 4px solid #9c854e;
}
.close {
    width: 0.46rem;
    height: 0.45rem;
    position: absolute;
    top: 0.24rem;
    right: 0.27rem;
}
.military_wrap {
    position: relative;
    width: 100%;
    overflow: hidden;
    .mask {
        & > img {
            width: 100%;
        }
        .mask_in {
            position: absolute;
            height: 3.97rem;
            top: 50%;
            margin-top: -1.985rem;
        }
    }
    .nav {
        width: 1.01rem;
        height: 4.16rem;
        position: absolute;
        top: 3.27rem;
        right: 0.94rem;
        background: url('.././../assets/imgs/hero/hero.png') no-repeat;
        background-size: 100% 100%;
        li {
            width: 1.01rem;
            height: 1.01rem;
            text-indent: -9999px;
            cursor: pointer;
            &.libg {
                &::before {
                    position: absolute;
                    right: 0;
                    top: 0;
                    content: '';
                    width: 1.01rem;
                    height: 1.01rem;
                    background: url('.././../assets/imgs/hero/hero_on.png')
                        no-repeat;
                    background-size: 1.01rem 4.16rem;
                    background-position: 200px 200px;
                    transition: all 0.9s;
                }
            }
            &.jun_on {
                &::before {
                    background-position: 0 0;
                }
            }
            &.gong_on {
                &::before {
                    background-position: 0 -1.05rem;
                    top: 1.1rem;
                }
            }
            &.qi_on {
                &::before {
                    background-position: 0 -2.14rem;
                    top: 2.2rem;
                }
            }
            &.bu_on {
                &::before {
                    background-position: 0 -3.2rem;
                    top: 3.3rem;
                }
            }
        }
    }
    .jun {
        .peo {
            width: 8rem !important;
            height: 9.43rem !important;
            left: 0 !important;
        }
        .info {
            width: 8.21rem !important;
            height: 1.12rem !important;
        }
        .corps {
            width: 8.23rem !important;
            height: 4.06rem !important;
        }
    }
    .gong {
        .peo {
            width: 7.72rem !important;
            height: 11.97rem !important;
            left: 0 !important;
        }
        .info {
            width: 8.31rem !important;
            height: 1.06rem !important;
        }
        .corps {
            width: 8.31rem !important;
            height: 4.06rem !important;
        }
        .camp_people {
            img {
                width: 5.44rem;
                height: 8.82rem;
                left: 2.3rem;
            }
        }
    }
    .qi {
        .peo {
            width: 8.27rem !important;
            height: 9.03rem !important;
            top: 1.77rem !important;
            left: 0 !important;
        }
        .info {
            width: 7.96rem !important;
            height: 0.94rem !important;
        }
        .corps {
            width: 8.95rem !important;
            height: 4.08rem !important;
        }
        .camp_people {
            img {
                width: 6.08rem;
                height: 8.82rem;
                left: 2.3rem;
            }
        }
    }
    .bu {
        .peo {
            width: 6.99rem !important;
            height: 10.2rem !important;
            top: 1.63rem !important;
            left: 0 !important;
        }
        .info {
            width: 8.37rem !important;
            height: 0.99rem !important;
        }
        .corps {
            width: 9.02rem !important;
            height: 4.8rem !important;
        }
        .camp_people {
            img {
                width: 6.56rem;
                height: 8.82rem;
                left: 2.3rem;
            }
        }
    }
    .people {
        img {
            display: inline-block;
            position: absolute;
            /**&:nth-child(1) {
                width: 0.92rem;
                height: 3.56rem;
                top: 0;
                left: 1.98rem;
            }
            &:nth-child(2) {
                width: 6.26rem;
                height: 8.94rem;
                top: 1.83rem;
                left: 1.17rem;
            }**/
        }
    }
    .camp_people {
        img {
            display: inline-block;
            position: absolute;
            width: 5.76rem;
            height: 8.82rem;
            left: 2.3rem;
            bottom: 0;
        }
    }
    .content {
        .img {
            display: inline-block;
            position: absolute;
            left: 8.68rem;
            top: 2.39rem;
            &:nth-child(1) {
                width: 8.1rem;
                height: 0.98rem;
                top: 2.39rem;
                left: 8.68rem;
            }
            &:nth-child(2) {
                width: 1.94rem;
                height: 0.44rem;
            }
            &.c_info {
                width: 7.18rem;
                height: 5.05rem;
            }
        }
        .corps_center {
            position: absolute;
            width: 8.21rem;
            height: 3.68rem;
            top: 4.79rem;
            left: 7.92rem;
            ol {
                display: flex;
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                align-items: top;
                flex-wrap: wrap;
                li {
                    width: 1.4rem;
                    height: 1.6rem;
                    /* background: pink;
                    opacity: 0.6;*/
                    position: absolute;
                    cursor: pointer;
                    &:nth-child(1) {
                        left: 0;
                    }
                    &:nth-child(2) {
                        left: 1.6rem;
                    }
                    &:nth-child(3) {
                        left: 3.22rem;
                    }
                    &:nth-child(4) {
                        left: 4.8rem;
                    }
                    &:nth-child(5) {
                        left: 6.4rem;
                    }
                    &:nth-child(6) {
                        left: 0;
                        top: 1.88rem;
                    }
                    &:nth-child(7) {
                        left: 1.6rem;
                        top: 1.88rem;
                    }
                    &:nth-child(8) {
                        left: 3.2rem;
                        top: 1.88rem;
                    }
                    &:nth-child(9) {
                        left: 4.8rem;
                        top: 1.88rem;
                    }
                    &:nth-child(10) {
                        left: 6.4rem;
                        top: 1.88rem;
                    }
                    img {
                        &:nth-child(2) {
                            position: absolute;
                            bottom: 0.4rem;
                            left: 0.05rem;
                            transition: all 0.9s;
                            &:hover {
                                transform: scale(1.1, 1.1);
                            }
                        }
                    }
                }
            }
        }
        .camp_all {
            position: absolute;
            width: 7.53rem;
            height: 1.36rem;
            top: 7.76rem;
            left: 8.39rem;
            border: 1px solid transparent;
            border-image: url('.././../assets/s_line.png') 0 0 100% 0 stretch;
            .jun_c2 {
                img {
                    width: 0.8rem;
                    height: 1.16rem;
                    margin-top: -0.2rem;
                    cursor: pointer;
                }
            }
            & > img {
                position: absolute;
                top: 0;
                left: 0;
            }
            ul {
                display: flex;
                justify-content: space-between;
                position: absolute;
                width: 100%;
                margin-top: 0.3rem;
                /**background: url('.././../assets/camp_jun/gw_jun.png')
                        no-repeat;
                background-size: 6.36rem 1.16rem;**/
                li {
                    width: 0.85rem;
                    height: 0.95rem;
                    background: green;
                    opacity: 0.8;
                }
            }
        }
    }
    .jun {
        .camp_people{
            img{
                height: 8.82rem;
                &:nth-child(1) {
                    width: 5.5rem;
                }
                &:nth-child(2) {
                    width: 7.46rem;
                    left:1.2rem;
                }
                &:nth-child(3) {
                    width: 6.62rem;
                }
            }
        }
        .corps_center {
            width: 7.72rem;
            left: 7.92rem;
            .top2 {
                margin-top: 0.33rem;
            }
            ol {
                li {
                    img {
                        &:nth-child(2) {
                            bottom: 0.54rem;
                        }
                    }
                }
            }
        }
    }
    .gong {
        .camp_people{
            img{
                height: 8.82rem;
                &:nth-child(1) {
                    width: 5.44rem;
                }
                &:nth-child(2) {
                    width: 7.91rem;
                    left: 1.2rem;
                }
                &:nth-child(3) {
                    width: 7.13rem;
                }
                &:nth-child(4) {
                    width: 5.98rem;
                }
                &:nth-child(5) {
                    width: 7.27rem;
                    left: 1.9rem;
                }
                &:nth-child(6) {
                    width: 6.55rem;
                }
                &:nth-child(7) {
                    width: 7.12rem;
                    left: 1.3rem;
                }
                &:nth-child(8) {
                    width: 8.09rem;
                    left: .3rem;
                }
                &:nth-child(9) {
                    width: 6.2rem;
                }
                &:nth-child(10) {
                    width: 6.08rem;
                }
                &:nth-child(11) {
                    width: 6.52rem;
                }
                &:nth-child(12) {
                    width: 6.38rem;
                }
                &:nth-child(13) {
                    width: 5.54rem;
                }
                &:nth-child(14) {
                    width: 6.17rem;
                }
            }
        }
        .corps_center {
            width: 7.72rem;
            height: 4.2rem;
            top: 4.1rem;
            left: 7.92rem;
            .top_gong {
                margin-top: -0.2rem;
            }
            ol {
                top: 0.8rem;
                li {
                    img {
                        &:nth-child(2) {
                            position: absolute;
                            bottom: 0.53rem;
                            left: 0.05rem;
                            transition: all 0.9s;
                            &:hover {
                                transform: scale(1.1, 1.1);
                            }
                        }
                    }
                }
            }
        }
    }
    .qi {
        .camp_people{
            img{
                height: 8.82rem;
                &:nth-child(1) {
                    width: 8.5rem;
                    left: .1rem;
                }
                &:nth-child(2) {
                    width: 8.86rem;
                    left: .6rem;
                }
                &:nth-child(3) {
                    width: 6.23rem;
                }
                &:nth-child(4) {
                    width: 7.51rem;
                    left: 1.5rem;
                }
                &:nth-child(5) {
                    width: 6.37rem;
                    left: 1.9rem;
                }
                &:nth-child(6) {
                    width: 6.59rem;
                }
                &:nth-child(7) {
                    width: 6.28rem;
                    left: 2.1rem;
                }
                &:nth-child(8) {
                    width: 6.28rem;
                }
                &:nth-child(9) {
                    width: 6.28rem;
                    left: 2.1rem;
                }
            }
        }
        .corps_center {
            width: 8.45rem;
            height: 4.06rem;
            top: 4.2rem;
            left: 7.92rem;
            .top_qi {
                margin-top: -0.2rem;
            }
            ol {
                top: 0.6rem;
                li {
                    cursor: pointer;
                    img {
                        &:nth-child(2) {
                            position: absolute;
                            bottom: 0.55rem;
                            left: 0.05rem;
                            transition: all 0.9s;
                            &:hover {
                                transform: scale(1.1, 1.1);
                            }
                        }
                    }
                }
            }
        }
    }
    .bu {
        .camp_people{
            img{
                height: 8.82rem;
                &:nth-child(1) {
                    width: 10.14rem;
                    left: .2rem;
                }
                &:nth-child(2) {
                    width: 9.57rem;
                    left: -.4rem;
                }
                &:nth-child(3) {
                    width: 6.48rem;
                    left: 1.9rem;
                }
                &:nth-child(4) {
                    width: 6.8rem;
                    left: 1.4rem;
                }
                &:nth-child(5) {
                    width: 8.26rem;
                    left: .5rem;
                }
                &:nth-child(6) {
                    width: 6.5rem;
                    left: 2rem;
                }
                &:nth-child(7) {
                    width: 5.78rem;
                    left: 2.2rem;
                }
                &:nth-child(8) {
                    width: 8.31rem;
                    left: 2rem;
                }
                &:nth-child(9) {
                    width: 6.8rem;
                    left: .9rem;
                }
                &:nth-child(10) {
                    width: 8.18rem;
                    left: 1.8rem;
                }
                &:nth-child(11) {
                    width: 5.56rem;
                }
            }
        }
        .corps_center {
            width: 8.61rem;
            height: 4.66rem;
            top: 3.6rem;
            left: 7.92rem;
            .top_bu {
                margin-top: -0.2rem;
            }
            ol {
                top: 0.7rem;
                li {
                    width: 16%;
                    height: 1.7rem;

                    margin-right: 2.8%;
                    margin-top: 0.6rem;
                    cursor: pointer;
                    img {
                        &:nth-child(2) {
                            position: absolute;
                            bottom: 0.55rem;
                            left: 0.05rem;
                            transition: all 0.9s;
                            &:hover {
                                transform: scale(1.1, 1.1);
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
